"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var EpisodeResource = /** @class */ (function (_super) {
    tslib_1.__extends(EpisodeResource, _super);
    function EpisodeResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EpisodeResource.endpoint = '/episodes';
    EpisodeResource.MODEL_NAME = 'episode';
    return EpisodeResource;
}(base_1.default));
exports.default = EpisodeResource;
//# sourceMappingURL=episode.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/episode.js
// module id = h4KH
// module chunks = 0